// Module
var code = "<span>{{ formatted }}</span> ";
// Exports
export default code;